const ExtraDetail = {
    software: {
        lifecycle: [
            {
                name: 'GA Date',
                text: 'The date in which the product is generally available through official vendor distributions or published by the vendor.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'EOL Date',
                text: 'End of life date, the last date when full support for a product is provided by the vendor (partial support may still be still available).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'OBS Date',
                text: 'Obsolete or end of support date, the last date in which any support is provided by the vendor.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            }
        ],
        windows10: [
            {
                name: '32-Bit Readiness',
                text: 'The software release\'s readiness for 32-bit Windows 10',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: '32-Bit Status',
                text: 'The software release\'s compatibility status for 32-bit Windows 10',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: '32-Bit Upgrade Path',
                text: 'The upgrade path for the software release to attain compatibility with 32-bit Windows 10',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: '64-Bit Readiness',
                text: 'The software release\'s readiness for 64-bit Windows 10',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: '64-Bit Status',
                text: 'The software release\'s compatibility status for 64-bit Windows 10',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: '64-Bit Upgrade Path',
                text: 'The upgrade path for the software release to attain compatibility with 64-bit Windows 10',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            }
        ],
        windows8: [
            {
                name: '32-Bit Readiness',
                text: 'The software release\'s readiness for 32-bit Windows 8',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: '32-Bit Status',
                text: 'The software release\'s compatibility status for 32-bit Windows 8',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: '32-Bit Upgrade Path',
                text: 'The upgrade path for the software release to attain compatibility with 32-bit Windows 8',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: '64-Bit Readiness',
                text: 'The software release\'s readiness for 64-bit Windows 8',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: '64-Bit Status',
                text: 'The software release\'s compatibility status for 64-bit Windows 8',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: '64-Bit Upgrade Path',
                text: 'The upgrade path for the software release to attain compatibility with 64-bit Windows 8',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            }
        ],
        windows7: [
            {
                name: '32-Bit Readiness',
                text: 'The software release\'s readiness for 32-bit Windows 7',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: '32-Bit Status',
                text: 'The software release\'s compatibility status for 32-bit Windows 7',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: '32-Bit Upgrade Path',
                text: 'The upgrade path for the software release to attain compatibility with 32-bit Windows 7',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: '64-Bit Readiness',
                text: 'The software release\'s readiness for 64-bit Windows 7',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: '64-Bit Status',
                text: 'The software release\'s compatibility status for 64-bit Windows 7',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: '64-Bit Upgrade Path',
                text: 'The upgrade path for the software release to attain compatibility with 64-bit Windows 7',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            }
        ],
        dos: [
            {
                name: 'Type',
                text: 'The field in DejaCode that identifies the high-level nature of a license category (i.e., Open Source or Proprietary).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'Category',
                text: 'The field in DejaCode that provides a major grouping for licenses describing the relationship between the licensor and licensee.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'License',
                text: 'The field in DejaCode that refers to the short name of the licenses that apply to the component.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'Is Primary License?',
                text: 'The field in DejaCode that indicates whether a named license assigned to a component is the primary named license for that component.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'Keywords',
                text: 'A field in DejaCode that provides general software categories.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            }

        ],
        infoSec: [
            {
                name: 'CPE URI',
                text: 'The generic syntax for Uniform Resource Identifiers (URI) for Common Platform Enumeration (CPE). This includes a formal name format, a method for checking names against a system, and a description format for binding.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'CPE Max CVSS Score',
                text: 'The maximum Common Vulnerability Scoring System (CVSS) value amongst all CVE entries that are associated with this CPE.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'CPE Max CVSS Severity',
                text: 'The maximum Common Vulnerability Scoring System (CVSS) Severity amongst all CVE entries that are associated with this CPE.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            }
        ],
        cve: [
            {
                name: 'CVE ID',
                text: 'The actual identifier for Common Vulnerabilities and Exposures (CVE), which is a unique common identifier (ID) for publicly-known information-security vulnerabilities in publicly-released software packages. The ID follows the format: CVE prefix + Year + Arbitrary Digits.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'CVE Summary',
                text: 'The summary of the issue/vulnerability impact described on the CVE.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'CVSS Score',
                text: 'The common Vulnerability Scoring System (CVSS) is an open framework for communicating the characteristics and impacts of IT vulnerabilities, which is adopted in the National Vulnerability Database (NVD).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'CVSS Severity',
                text: 'The order of severity based on CVSS score.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'CVE Published Date',
                text: 'The date that the CVE entry was last modified in the NVD. This refers to \'ns2:last-modified-datetime\' column in CPE Dictionary, which is published by the U.S. National Institute for Standards and Technology (NIST).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            }

        ]
    },
    hardware: {
        lifecycle: [
            {
                name: 'Intro Date',
                text: 'The date the hardware was introduced or announced by the vendor.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'GA Date',
                text: 'The date that the product is generally available through official vendor distributions.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'Last Avail. Date',
                text: 'The last date in which the hardware is available for purchase from the vendor.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'OBS Date',
                text: 'Obsolete or end of support date, the last date in which any support is provided by the vendor.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            }
        ],
        specs: [
            {
                name: 'AC Avg Unit',
                text: 'The unit for AC_POWER_AVG column (watt or volt-amp).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'AC Frequency Max',
                text: 'The manufacturer\'s suggested AC input requirements, i.e. the maximum frequency (whether the voltage switch is turned on low/high or when the device has no voltage switch).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'AC Frequency Min',
                text: 'The manufacturer\'s suggested AC input requirements, i.e. the minimum frequency (whether the voltage switch is turned on low/high or when the device has no voltage switch).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'AC Heat Dissipation (Avg)',
                text: 'The average amount of heat per-unit of time generated by the device during typical use when it is hooked up to AC power (in BTU/hr).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'AC Phase',
                text: 'The phase of the AC.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'AC Power Avg',
                text: 'The average amount of power (energy per-unit of time) consumed by the device during typical use when it is hooked up to AC power (in watt or volt-amp).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'AC Power Max',
                text: 'The peak or maximum amount of power (energy per-unit of time) consumed by the device when it is hooked up to AC power (in watt or volt-amp).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'AC Heat Dissipation (Max)',
                text: 'The peak or maximum amount of heat per-units of time generated by the device during typical usage when it is hooked up to AC power (in BTU/hr).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'AC Max Unit',
                text: 'The unit for the AC_POWER_MAX column (watt or volt-amp).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'AC Input Single/Low Setting Voltage Min (Volt AC)',
                text: 'Manufacturer\'s suggested AC electrical input requirements: The minimum voltage when the voltage switch is turned on to the low range setting, or when the device has no voltage switch (single voltage range).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'AC Input Single/Low Setting Voltage Max (Volt AC)',
                text: 'Manufacturer\'s suggested AC electrical input requirements: The maximum voltage when the voltage switch is turned on to the low range setting, or when the device has no voltage switch (single voltage range).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'AC Input Single/Low Setting Current Min (Amp)',
                text: 'Manufacturer\'s suggested AC electrical input requirements: The minimum current when the voltage switch is turned on to the low range setting, or when the device has no voltage switch (single voltage range).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'AC Input Single/Low Setting Current Max (Amp)',
                text: 'Manufacturer\'s suggested AC electrical input requirements: The maximum current when the voltage switch is turned on to the low range setting, or when the device has no voltage switch (single voltage range).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'AC Input High Setting Voltage Min (Volt AC)',
                text: 'Manufacturer\'s suggested AC electrical input requirements: The minimum voltage when the voltage switch is turned to on the high range setting.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'AC Input High Setting Voltage Max (Volt AC)',
                text: 'Manufacturer\'s suggested AC electrical input requirements: The maximum voltage when the voltage switch is turned on to the high range setting.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'AC Input High Setting Current Min (Amp)',
                text: 'Manufacturer\'s suggested AC electrical input requirements: The minimum current when the voltage switch is turned on to the high range setting.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'AC Input High Setting Current Max (Amp)',
                text: 'Manufacturer\'s suggested AC electrical input requirements: The maximum current when the voltage switch is turned on the high range setting.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'Battery Life',
                text: 'Hours of possible battery life.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'Battery Type',
                text: 'Battery Type.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'DC Heat Dissipation (Avg)',
                text: 'The average amount of heat per-unit of time generated by the device during typical use when it is hooked up to DC power (in BTU/hr).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'DC Heat Dissipation (Max)',
                text: 'The peak or maximum amount of heat per-unit of time generated by the device when it is hooked up to DC power (in BTU/hr).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'DC High Current',
                text: 'The manufacturer\'s suggested DC input requirements, i.e. the current when the voltage switch is turned on the high setting.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'DC High Voltage',
                text: 'The manufacturer\'s suggested DC input requirement, i.e. the voltage when the voltage switch is turned on the high setting.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'DC Low Current',
                text: 'The manufacturer\'s suggested DC input requirements, i.e. the current when the voltage switch is turned on the low setting or when the device has no voltage switch (single voltage).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'DC Low Voltage',
                text: 'The manufacturer\'s suggested DC input requirements, i.e. the voltage when the voltage switch is turned on the low setting or when the device has no voltage switch (single voltage).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'DC Power (Avg)',
                text: 'The average amount of power (energy per-unit of time) consumed by the device during typical use when it is hooked up to DC power (in watt or volt-amp).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'DC Power (Max)',
                text: 'The peak or maximum amount of power (energy per-unit of time) consumed by the device when it is hooked up to DC power (in watt or volt-amp).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'Dedicated Circuit',
                text: 'Listing of the dedicated circuit.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'Emergency Power',
                text: 'Listing of the emergency power.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'Energy Star',
                text: 'This is a flag to indicate whether the device has earned the Energy Star certification or not.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'EPEAT',
                text: 'This is a flag to indicate which EPEAT certification the device has earned: Gold, Silver, or Bronze.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'Max Non-Operating Humidity',
                text: 'The manufacturer\'s suggested peak or maximum humidity (percentage) of the device when it is non-operational or in storage.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'Max Non-Operating Temperature',
                text: 'The manufacturer\'s suggested peak or maximum temperature of the device when it is non-operational or in storage (in Fahrenheit).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'Max Operating Humidity',
                text: 'The manufacturer\'s suggested peak or maximum humidity (percentage) of the device during operation.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'Max Operating Temperature',
                text: 'The manufacturer\'s suggested peak or maximum temperature of the device during operation (in Fahrenheit).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'Min Non-Operating Humidity',
                text: 'The manufacturer\'s suggested minimum humidity (percentage) of the device when it is non-operational or in storage.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'Min Non-Operating Temperature',
                text: 'The manufacturer\'s suggested minimum temperature of the device when it is non-operational or in storage (in Fahrenheit).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'Min Operating Humidity',
                text: 'The manufacturer\'s suggested minimum humidity (percentage) of the device during operation.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'Min Operating Temperature',
                text: 'The manufacturer\'s suggested minimum temperature of the device during operation (in Fahrenheit).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'Plug Type',
                text: 'Plug Type (NEMA).',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            },{
                name: 'Power Rating',
                text: 'The summary of the device\'s various power ratings: Voltage, Frequency, and Current.',
                link: 'https://www.flexera.com/enterprise/company/about/contact-us/',
                linkDes: 'Contact us. This link will open in a new window.'
            }
        ]
    }
  }

  export default ExtraDetail;



// WEBPACK FOOTER //
// ./src/config/ExtraDetail.js